import { NgClass } from '@angular/common'
import { Component, input, output } from '@angular/core'
import { DeliveryChannel, DeliveryChannelTab } from '../../../../../helpers/delivery-status-help'

@Component({
  selector: 'app-delivery-channel-tabs',
  standalone: true,
  imports: [NgClass],
  templateUrl: './delivery-channel-tabs.component.html',
  styleUrl: './delivery-channel-tabs.component.scss'
})
export class DeliveryChannelTabsComponent {
  public readonly tabs = input.required<readonly DeliveryChannelTab[]>()
  public readonly activeId = input.required<DeliveryChannel>()
  public readonly tabChange = output<DeliveryChannel>()

  /**
   * Emits the tab change event.
   * @param id - The ID of the tab.
   */
  public onTabClick(id: DeliveryChannel): void {
    if (id === this.activeId()) return
    this.tabChange.emit(id)
  }

  /**
   * Returns the class names for the tab button.
   * @param tabId - The ID of the tab.
   * @returns The class names for the tab button.
   */
  public tabButtonClass(tabId: DeliveryChannel): Record<string, boolean> {
    const isActive = this.activeId() === tabId
    return {
      'tw-border-blue-600': isActive,
      'tw-text-blue-600': isActive,
      'tw-border-transparent': !isActive,
      'tw-text-gray-500': !isActive
    }
  }

  /**
   * Returns the class names for the tab icon.
   * @param tabId - The ID of the tab.
   * @returns The class names for the tab icon.
   */
  public tabIconClass(tabId: DeliveryChannel): Record<string, boolean> {
    const isActive = this.activeId() === tabId
    return {
      'tw-text-blue-600': isActive,
      'tw-fill-blue-600': isActive,
      'tw-text-gray-500': !isActive,
      'tw-fill-gray-500': !isActive
    }
  }
}
